import {
  SELECT_DATE,
  SELECT_TIME,
  SELECT_DURATION,
  SELECT_REASON,
  SELECT_EMOJI,
  MEDITATION_SAVING_ERROR,
  MEDITATION_SAVING_SUCCESS,
  SAVE_MEDITATION_LINK,
  SAVE_MEDITATION_GRADIENT,
  DATA_IS_BEING_FETCHED,
  DATA_FETCH_SUCCESS,
  SET_MEDITATION_ID,
  RESET_MEDITATION_STATE,
} from '../constants/types';

const initialState = {
  date: null,
  time: null,
  duration: 10,
  isExampleMeditation: true,
  reason: null,
  emoji: null,
  meditationSavingError: '',
  meditationRef: localStorage.getItem('newMeditationRef') || null,
  meditationLink: null,
  meditationGradient: 'gradient_00',
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SELECT_DATE: {
      return {
        ...state,
        date: action.payload,
      }
    }
    case SELECT_TIME: {
      return {
        ...state,
        time: action.payload,
      }
    }
    case SELECT_DURATION: {
      return {
        ...state,
        duration: action.payload,
        isExampleMeditation: false,
      }
    }
    case SELECT_REASON: {
      return {
        ...state,
        reason: action.payload,
      }
    }
    case SELECT_EMOJI: {
      return {
        ...state,
        emoji: action.payload,
      }
    }
    case MEDITATION_SAVING_SUCCESS: {
      return {
        ...state,
        meditationSavingError: '',
        meditationRef: action.payload,
      }
    }
    case MEDITATION_SAVING_ERROR: {
      return {
        ...state,
        meditationSavingError: 'Something went wrong, please try again',
      }
    }
    case SAVE_MEDITATION_LINK: {
      return {
        ...state,
        meditationLink: action.payload,
      }
    }
    case SAVE_MEDITATION_GRADIENT: {
      return {
        ...state,
        meditationGradient: action.payload,
      }
    }
    case DATA_IS_BEING_FETCHED: {
      return {
        ...state,
        isFetching: true,
      }
    }
    case DATA_FETCH_SUCCESS: {
      return {
        ...state,
        isFetching: false,
      }
    }
    case SET_MEDITATION_ID: {
      return {
        ...state,
        meditationRef: action.payload,
      }
    }
    case RESET_MEDITATION_STATE: {
      return {
        ...state,
        duration: 10,
        reason: null,
        emoji: null,
        meditationGradient: 'gradient_00',
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/newMeditation.js